import { CountyCmsSchoolsTable } from './CountyCmsSchoolsTable';
export default CountyCmsSchoolsTable;
